import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "./services/rootReducer";

// const initialState = {};
const persistConfig = {
  key: "default",
  storage: storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = () => {
  let store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk],
  });
  let persistor = persistStore(store);
  //persistor.purge();
  return { store, persistor };
};

export default store;
